import { useEffect } from "react";
import { RequestState } from "../../../constants/request-state";
import { isRequestNone } from "../../../utils";
import { useAppDispatch } from "../../../effects/useAppDispatch";
import { transactionNotesService } from "../../../services/transaction-notes.service";
import { errorActions } from "../../../actions";
import { useAppSelector } from "../../../effects/useAppSelector";
import { transactionNoteActions } from "../../../actions/entities/transaction-note.actions";

export function useTransactionNotes(dealReferenceName: string, transactionReferenceName: string) {
    const dispatch = useAppDispatch();

    const { requestState, notes } = useAppSelector(s => s.entities.transactionNote.notesByTransaction[transactionReferenceName]) ?? {
        requestState: RequestState.none,
        notes: []
    };

    useEffect(() => {
        if (!isRequestNone(requestState)) return;

        const doRequest = async () => {
            try {
                dispatch(transactionNoteActions.requestNotes(transactionReferenceName));
                const notes = await transactionNotesService.getNotes(dealReferenceName, transactionReferenceName);
                dispatch(transactionNoteActions.requestResult(transactionReferenceName, RequestState.success, notes));
            } catch (e) {
                dispatch(errorActions.unexpectedError(e));
                dispatch(transactionNoteActions.requestResult(transactionReferenceName, RequestState.failure, []));
            }
        }

        doRequest();
    }, [dealReferenceName, transactionReferenceName, requestState, dispatch])

    return { requestState, notes };
}